export default __webpack_public_path__ + "static/media/vehelix_alert.5dd482ff.svg";